// Global Instructions Rule Applied!
//
// Configuration → Pipelines master grid row (view__pipelines_admin): a pipeline
// with its type/fund labels, stage + deal counts, and the days-in-pipeline
// thresholds. passthrough() so the grid tolerates additive RPC keys.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const PipelinesAdminGridSchema = z
  .object({
    pipelines__id: z.string(),
    pipelines__name: z.string().nullish(),
    pipelines__type: z.string().nullish(),
    pipelines__type__label: z.string().nullish(),
    pipelines__default: z.boolean().nullish(),
    pipelines__default_fund: z.string().nullish(),
    pipelines__default_fund__label: z.string().nullish(),
    pipelines__pipeline_warn_days: z.number().nullish(),
    pipelines__pipeline_warn_colour: z.string().nullish(),
    pipelines__pipeline_crit_days: z.number().nullish(),
    pipelines__pipeline_crit_colour: z.string().nullish(),
    pipelines__stage_count: z.number().nullish(),
    pipelines__deal_count: z.number().nullish(),
    pipelines__alert_recipient_count: z.number().nullish(),
    stage_alert_recipients: z
      .array(
        z.object({
          stage_alert_recipients__id: z.string(),
          stage_alert_recipients__email: z.string()
        })
      )
      .nullish()
  })
  .passthrough()

export type PipelinesAdminGridModel = z.infer<typeof PipelinesAdminGridSchema>

export function validatePipelinesAdminGrid(data: unknown): PipelinesAdminGridModel {
  return validateWithZodSchema(PipelinesAdminGridSchema, data, 'pipelines admin grid') as PipelinesAdminGridModel
}
